module.exports = [{"assessmentID":1,"name":"Welcome To PLEX","totalStudents":300}]


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/institutions/list.json
// module id = 2535
// module chunks = 0